// extracted by mini-css-extract-plugin
module.exports = {"Body":"Body_Body__GuGAe"};